import * as React from "react";
import { MoneyDisplayHelper } from "../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { RadiosEditor } from "../../../../../../../react-core/Html/RadiosEditor";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { DrawdownIncomeAmendmentModel } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeAmendmentModel";
import { MoneyHelper } from "../../../../../../Shared/Common/MoneyHelper";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { processTypeEnum } from "../../../Common/Resource/Contents";
import { ChooseAssetsToSell } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import {
    getSellableAssets,
    getUpdatedAssetsToSell,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import { ChooseAssetsToSellAssets } from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { CappedFlexiSection } from "../../../Common/SIPP/IncomePaymentDetails/CappedFlexiSection";
import { calculateAnnualIncomeAmount, calculateAnnualIncomeAmountWithPaymentEnd, frequencyMap, getAssetsToSellTotalForIncomeFromIncome, calculateBalanceFrequency, changeDateByFrequency, getTotalIncome } from "../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import IncomeBankDetails from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import IncomeRequired from "../../../Common/SIPP/IncomePaymentDetails/IncomeRequired";
import RegularIncomePayment from "../../../Common/SIPP/IncomePaymentDetails/RegularIncomePayment";
import {
    incomePaymentDetailsLabels,
    incomePaymentDetailsMessages,
} from "../../../Common/SIPP/IncomePaymentDetails/Resource/Content";
import { ITFCIncome } from "./ITFCIncome";
import { RestrictionHelper } from "../../../../../../Shared/Common/RestrictionHelper";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { RestrictionAction } from "../../../Common/Restrictions/RestrictionAction";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { PaymentMethod } from "../../../../../../../Wrap/Constants/Enums/Domain/PaymentMethod";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";
import { IJsonDate } from "../../../../../../../Wrap/System/IJsonDate";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { BusinessDaysAction } from "../../../../Common/BusinessDays/Actions/BusinessDaysAction";
import _, { first } from "lodash";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { IncomePaymentDestination } from "../../../../../../../Wrap/Constants/Enums/Domain/IncomePaymentDestination";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";

interface IIncomePaymentDetailsProps extends IProcessComponentProps {
    data: PensionContributionModel;
    isLoading: boolean;
    extraInfo?: any;
    processType: processTypeEnum;
    subAccountType?: SubAccountType;
}

interface IIncomePaymentDetailsState {
    assets: ChooseAssetsToSellAssets[];
    isIncomeRequired: boolean;
    assetDictionary: Map<number, ProductType>;
}

export class IncomePaymentDetails extends ProcessComponent<IIncomePaymentDetailsProps, IIncomePaymentDetailsState> {
    _isMounted = false;

    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
            isIncomeRequired: false,
            assetDictionary: null,
        };
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        super.componentDidMount();

        const data = this.getDrawdownIncomeAmendmentModel();
        this.getSellableAssets();
        if (!isNullOrEmpty(data?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations)) {
            this.props.onChange({ IsAcrossAllAssets: false });
        }
        if (RestrictionStore.getData() == null) {
            if (!CommonHelper.isNullOrEmpty(getQueryParameters()["subaccounthierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["subaccounthierarchyid"]);
            } else if (!CommonHelper.isNullOrEmpty(getQueryParameters()["hierarchyid"])) {
                RestrictionAction.getRestrictionByHierarchyId(getQueryParameters()["hierarchyid"]);
            }
        }

        if (data?.DrawdownIncomeAmendmentInstruction?.Income?.PaymentMethod) {
            this.handleChange(
                { PaymentMethod: data?.DrawdownIncomeAmendmentInstruction?.Income?.PaymentMethod },
                "Income"
            );
        }
    }

    private getDrawdownIncomeAmendmentModel(): DrawdownIncomeAmendmentModel {
        const data = this.props.data;
        return data?.Contribution?.DrawdownIncomeAmendmentModel;
    }

    private getHasCappedArrangements(): boolean {
        const data = this.getDrawdownIncomeAmendmentModel();
        return (data?.DrawdownIncomeAmendmentInstruction?.CappedArrangements != null &&
            data?.DrawdownIncomeAmendmentInstruction?.CappedArrangements.length > 0);
    }

    private getSellableAssets = () => {
        const params = getQueryParameters();
        const hierarchyId = params["hierarchyid"];
        SubAccountTypeHelper.getSubAccountHierarchyId(hierarchyId, SubAccountType.Npr, (subAccountHierarchyId) => {
            getSellableAssets(SubAccountType.Npr, hierarchyId, subAccountHierarchyId, (data) => {
                if (this._isMounted) {
                    const updateAssets = getUpdatedAssetsToSell([], 0, data?.assetsToSell);
                    this.setState({
                        assets: updateAssets,
                        assetDictionary: this.constructAssetDictionary(updateAssets),
                    });
                }
            });
        });
    };

    private constructAssetDictionary(assetArray: ChooseAssetsToSellAssets[]): Map<number, ProductType> {
        let result = new Map<number, ProductType>();
        for (let asset of assetArray) {
            if (!(asset.Id in result)) {
                result[asset.Id] = asset.ProductType;
            }
        }
        return result;
    }

    private checkDisinvestmentHasOnlyCashOrEmpty(disinvestmentAllocations: Array<InvestmentAllocation>): boolean {
        if (!disinvestmentAllocations) {
            return true;
        }

        const { assetDictionary } = this.state;

        return !disinvestmentAllocations.some(
            (allocation) =>
                allocation?.Percentage > 0 &&
                allocation?.ProductId > 0 &&
                assetDictionary?.[allocation?.ProductId] != ProductType.Cash
        );
    }

    private async daysAfterNow(days): Promise<Date> {
        const resultDate = await this.getBusinessDays(new Date(Date.now()), true, days);
        if (resultDate.getDate() > 28) {
            resultDate.setMonth(resultDate.getMonth() + 1);
            resultDate.setDate(1);
        }
        return resultDate;
    }

    private getBusinessDays(baseDate, future, numberOfDays): Promise<Date> {
        return new Promise((resolve) => {
            BusinessDaysAction.GetBusinessDays(baseDate, future, numberOfDays, true, (d) => {
                resolve(JsonDateParser.toDateNoOffset(d));
            });
        });
    }

    private getDrawdownIncomeModelProps = (data: DrawdownIncomeAmendmentModel, onChange) => {
        return {
            data: data?.DrawdownIncomeAmendmentInstruction,
            onChange: (v) => this.handleChange(v),
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
        };
    };

    private onIncomeReviewChange(changes) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            changes,
            data.Contribution,
            "DrawdownIncomeReviewDetails"
        );
    }

    private async handleChange(changes, key?: string) {
        const { data, onChange } = this.props;
        const model = this.getDrawdownIncomeAmendmentModel();

        var updatedModel = _.cloneDeep(model);
        this.applyChangesToClonedModel(
            changes,
            key ? updatedModel.DrawdownIncomeAmendmentInstruction[key] : updatedModel.DrawdownIncomeAmendmentInstruction
        );

        if (key == "Income" && changes["Frequency"]) {
            this.handleFrequencyChange(changes, updatedModel);
        }

        if (key == "Income" && ("PaymentEnd" in changes || changes["NextPayment"])) {
            this.handleAnnualAmountChange(changes, updatedModel);
            this.handleCappedCurrentPensionYearIncomeChange(changes, updatedModel);
        }

        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "Contribution");
            },
            updatedModel,
            data.Contribution,
            "DrawdownIncomeAmendmentModel"
        );
    }

    private applyChangesToClonedModel(changes, model) {
        for (const item in changes) {
            model[item] = JSON.parse(JSON.stringify(changes[item]));
        }
    }

    private handleAnnualAmountChange(changes, updatedModel: DrawdownIncomeAmendmentModel) {
        const annualIncome = updatedModel?.DrawdownIncomeAmendmentInstruction?.Income;
        let grossIncomePerPayment = changes["GrossIncomePerPayment"] ?? annualIncome?.GrossIncomePerPayment;
        let incomeFrequency = changes["Frequency"] ?? annualIncome?.Frequency;
        let paymentEnd = changes["PaymentEnd"] ?? annualIncome.PaymentEnd;
        let firstPaymentDate = changes["NextPayment"] ?? annualIncome.NextPayment;

        if (annualIncome.TakeDifferentInitialIncomePayment)
        {
            firstPaymentDate = changeDateByFrequency(firstPaymentDate, incomeFrequency, 1);
        }

        if (grossIncomePerPayment?.Amount != null && grossIncomePerPayment?.Amount != undefined &&
            incomeFrequency != null && incomeFrequency != undefined) {

            updatedModel.DrawdownIncomeAmendmentInstruction.Income.AnnualAmount = {
                Amount:
                    paymentEnd != null && firstPaymentDate != null
                        ? calculateAnnualIncomeAmountWithPaymentEnd(
                              grossIncomePerPayment.Amount,
                              incomeFrequency,
                              firstPaymentDate,
                              paymentEnd
                          )
                        : calculateAnnualIncomeAmount(grossIncomePerPayment.Amount, incomeFrequency),
            };
        }
    }

    private handleCappedCurrentPensionYearIncomeChange(changes, updatedModel: DrawdownIncomeAmendmentModel) {
        const income = updatedModel?.DrawdownIncomeAmendmentInstruction?.Income;
        const cappedArrangements = updatedModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements;

        if (!income?.TargetSpecificArrangements || !cappedArrangements) {
            return;
        }

        const nextPaymentDate = income.NextPayment ? JsonDateParser.toDateNoOffset(income.NextPayment) : null;

        if (!nextPaymentDate) {
            return;
        }

        updatedModel.DrawdownIncomeAmendmentInstruction.CappedArrangements = cappedArrangements.map((item) => {
            const shouldDisableCurrentYearIncome = () => {
                if (!income.NextPayment || !item.NextGadStartDate) {
                    return false;
                }

                const nextPaymentDate = JsonDateParser.toDateNoOffset(income.NextPayment);
                const nextYearGadStartDate = JsonDateParser.toDateNoOffset(item.NextGadStartDate);

                const endOfCurrentPensionYear = new Date(nextYearGadStartDate);
                endOfCurrentPensionYear.setDate(endOfCurrentPensionYear.getDate() - 1);

                return nextPaymentDate > endOfCurrentPensionYear;
            };

            const isDisabled =
                item.MaximumIncomePaymentForRemainderOfPensionYear <= 0 || shouldDisableCurrentYearIncome();

            if (isDisabled && item.IncomePerPaymentForCurrentPensionYear !== 0) {
                return {
                    ...item,
                    IncomePerPaymentForCurrentPensionYear: 0,
                };
            }

            return item;
        });
    }

    private handleFrequencyChange(changes, updatedModel: DrawdownIncomeAmendmentModel) {
        this.handleAnnualAmountChange(changes, updatedModel);

        // calculate Maximum IncomePayment For Remainder Of PensionYear according to the frequency
        const income = updatedModel?.DrawdownIncomeAmendmentInstruction?.Income;

        if (updatedModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements?.length && income) {
            updatedModel.DrawdownIncomeAmendmentInstruction.CappedArrangements.forEach((item) => {
                const remainder = (item.GadMaximum || 0) - (item.IncomeTakenToDate || 0);
                const balanceFrequency = calculateBalanceFrequency(
                    item.GadStartDate,
                    income.NextPayment,
                    income.PaymentEnd,
                    income.Frequency
                );

                item.MaximumIncomePaymentForRemainderOfPensionYear =
                    balanceFrequency > 0
                        ? Number((remainder / balanceFrequency).toFixed(2))
                        : Number(remainder.toFixed(2));
            });
        }

        // calculate maximum per payment according to the frequency
        const frequencyValue = frequencyMap[changes.Frequency] as number;
        if (updatedModel?.DrawdownIncomeAmendmentInstruction?.FlexiArrangements?.length) {
            updatedModel.DrawdownIncomeAmendmentInstruction.FlexiArrangements.forEach((item) => {
                if (item.Type != "Accumulation") {
                    item.MaximumIncomePerPayment = Number(((item?.Amount ?? 0) / frequencyValue).toFixed(2));
                }
            });
        }
        updatedModel.DrawdownIncomeAmendmentInstruction.Income.TakeFullValue = false;
    }

    private handleDrawdownIncomeModelChange(changes, key?: keyof DrawdownModel) {
        const { data, onChange } = this.props;

        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "Contribution");
            },
            changes,
            data.Contribution,
            "DrawdownModel"
        );
    }

    public render(): JSX.Element {
        const { onChange, extraInfo, processType, subAccountType } = this.props;
        const data = this.getDrawdownIncomeAmendmentModel();
        const pensionBase = this.props.data;
        let isRestrictionActive = false;
        let restrictedMessage = "An account with suspended or restricted activities cannot edit income payments";
        if (RestrictionHelper.shouldHandleRestriction(processType)) {
            isRestrictionActive = RestrictionStore.WithdrawDisabled();
        }
        const existingArrangements = {
            CappedModels: data?.DrawdownIncomeAmendmentInstruction?.CappedArrangements,
            FlexiModels: data?.DrawdownIncomeAmendmentInstruction?.FlexiArrangements,
        };
        const modelData: DrawdownModel = {
            DrawdownType: DrawdownType.Capped,
            IsAcrossAllAssets: pensionBase?.Contribution?.DrawdownModel?.IsAcrossAllAssets,
        };
        const hasBankDestination = data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations?.some(
            (alloc) => alloc.Destination == IncomePaymentDestination.BankAccount
        );
        const bankAccountDestinations = data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations?.filter
            (alloc => alloc.Destination == IncomePaymentDestination.BankAccount).map(x => x.BankAccountId) ?? [];
        const hasInternationalBankAccountDestination = bankAccountDestinations?.some(x => {
            var allBankAccounts = extraInfo.AllBankAccounts ?? [];
            const bankAccount = allBankAccounts.find((ba) => ba.BankAccountId === x);
            return bankAccount && bankAccount.BankCountry !== CountryCode.GBR;
        });
        
        return (
            <PartLoading isLoading={this.props.isLoading}>
                <h2>Income payment details</h2>
                {isRestrictionActive && <Alert alertType={AlertType.Error} message={restrictedMessage} />}
                <ITFCIncome
                    {...this.getDrawdownIncomeModelProps(data, onChange)}
                    subaccountHierarchyid={getQueryParameters()["subaccounthierarchyid"]}
                />
                <RadiosEditor
                    cssWrapper="rg-inline mb-16"
                    label={incomePaymentDetailsLabels.needToProvideAnIncome}
                    disabled={isRestrictionActive}
                    selected={
                        data?.DrawdownIncomeAmendmentInstruction?.Income?.TaxableIncomeRequiredInAddition || false
                    }
                    options={[true, false]}
                    getText={(v) => (v ? "Yes" : "No")}
                    onChange={(v) => {
                        if (!v) {
                            this.handleChange(
                                {
                                    GrossIncomePerPayment: { Amount: 0, Currency: CurrencyCode.GBP },
                                    CurrentYearIncome: { Amount: 0, Currency: CurrencyCode.GBP },
                                    AnnualAmount : { Amount: { Amount: 0, Currency: CurrencyCode.GBP } },
                                    TaxableIncomeRequiredInAddition: v,
                                },
                                "Income"
                            );
                        } else {
                            this.handleChange({ TaxableIncomeRequiredInAddition: v }, "Income");
                        }
                    }}
                />
                {data?.DrawdownIncomeAmendmentInstruction?.Income?.TaxableIncomeRequiredInAddition && (
                    <>
                        <IncomeRequired
                            data={data?.DrawdownIncomeAmendmentInstruction?.Income}
                            onChange={(changes) => {
                                this.handleChange(changes, "Income");
                            }}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            onRef={(ref) => this.appendChild(ref)}
                            processType={processTypeEnum.EditIncomePayments}
                            drawdownType={DrawdownType.Flexible}
                            pensionTransfer={[]}
                            pensionBase={this.props?.data?.Contribution}
                            isITFC={false}
                            hasCappedArrangement={this.getHasCappedArrangements()}
                        />
                        {data?.DrawdownIncomeAmendmentInstruction?.Income?.TargetSpecificArrangements && (
                            <CappedFlexiSection
                                data={existingArrangements}
                                onChange={(changes, type) => {
                                    const convertedChanges =
                                        type === "CappedModels"
                                            ? { CappedArrangements: changes?.CappedModels }
                                            : { FlexiArrangements: changes?.FlexiModels };
                                    const convertedKey =
                                        type === "CappedModels" ? "CappedArrangements" : "FlexiArrangements";
                                    this.handleChange(convertedChanges[convertedKey], convertedKey);
                                }}
                                income={data?.DrawdownIncomeAmendmentInstruction?.Income}
                                onIncomeChange={(changes) => this.handleChange(changes, "Income")}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onRef={(ref) => this.appendChild(ref)}
                                drawdownType={DrawdownType.Flexible}
                                drawdownIncomeReview={this.props.data.Contribution?.DrawdownIncomeReviewDetails}
                                onIncomeReviewChange={(changes) => this.onIncomeReviewChange(changes)}
                                processType={processTypeEnum.EditIncomePayments}
                            />
                        )}
                        <RegularIncomePayment
                            data={data?.DrawdownIncomeAmendmentInstruction?.Income}
                            onChange={(changes) => {
                                this.handleChange(changes, "Income");
                            }}
                            labels={incomePaymentDetailsLabels}
                            messages={incomePaymentDetailsMessages}
                            shouldHidePaymentMethod={!hasBankDestination}
                            onRef={(ref) => this.appendChild(ref)}
                            processType={processTypeEnum.EditIncomePayments}
                            drawdownType={DrawdownType.Flexible}
                            pensionBase={this.props?.data?.Contribution}
                            isITFC={false}
                            subaccountHierarchyid={getQueryParameters()["subaccounthierarchyid"]}
                            hasInternationalBankAccountDestination={hasInternationalBankAccountDestination}
                            sellableAssets={this.state.assets}
                        />
                        <ChooseAssetsToSell
                            data={{ IsAcrossAllAssets: pensionBase?.Contribution?.DrawdownModel?.IsAcrossAllAssets }}
                            onChange={(value) => {
                                this.handleDrawdownIncomeModelChange(value, "IsAcrossAllAssets")
                                this.handleChange({ IncomeDisinvestmentAllocations: value[TableKeys.IncomeDisinvestmentAllocations] });
                            }}
                            sectionHeader={`Choose assets to sell to pay income (${MoneyDisplayHelper.FromatMoneyDisplay(
                                getTotalIncome(
                                    this.props.data?.Contribution?.DrawdownModel,
                                    data?.DrawdownIncomeAmendmentInstruction,
                                    this.props.data?.Contribution
                                ),
                                MoneyHelper.getDefaultCurrency()
                            )})`}
                            onRef={(ref) => this.appendChild(ref)}
                            assets={this.state.assets}
                            processType={processTypeEnum.GadReview}
                            tableKey={TableKeys.IncomeDisinvestmentAllocations}
                        />
                        {pensionBase?.Contribution?.DrawdownModel?.IsAcrossAllAssets == false && (
                            <ChooseAssetsToSellTable
                                data={data?.DrawdownIncomeAmendmentInstruction?.IncomeDisinvestmentAllocations || []}
                                tableData={this.state.assets}
                                modelData={modelData}
                                reason={ChooseAssetsToSellFor.Income}
                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                onRef={(ref) => this.appendChild(ref)}
                                onChange={(v) => {
                                    this.handleChange({ IncomeDisinvestmentAllocations: v });
                                }}
                                processType={ProcessType.GadReview}
                                disableOffPlatform={true}
                                pensionBase={this.props.data?.Contribution}
                                drawdownIncomeAmendmentInstruction={data?.DrawdownIncomeAmendmentInstruction}
                                gadReviewtotalValue={getTotalIncome(
                                    this.props.data?.Contribution?.DrawdownModel,
                                    data?.DrawdownIncomeAmendmentInstruction,
                                    this.props.data?.Contribution
                                )}
                            />
                        )}
                        <hr />
                        {/* <BankDetails
                            data={data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations || []}
                            onChange={(value) => {
                                this.handleChange({ IncomePaymentAllocations: value }, "Income");
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                            allBankAccounts={extraInfo?.AllBankAccounts}
                        /> */}
                        <IncomeBankDetails
                            data={data?.DrawdownIncomeAmendmentInstruction?.Income?.IncomePaymentAllocations || []}
                            onChange={(value) => {
                                let parentIncome = data?.DrawdownIncomeAmendmentInstruction?.Income;
                                if (parentIncome) {
                                    parentIncome.IncomePaymentAllocations = value;
                                    this.handleChange(parentIncome, "Income");
                                }
                            }}
                            onRef={(ref) => this.appendChild(ref)}
                            allBankAccounts={extraInfo?.AllBankAccounts}
                            showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                            showPropotionOfIncome={
                                data?.DrawdownIncomeAmendmentInstruction?.Income?.TaxableIncomeRequiredInAddition
                            }
                            bankAccountInstructions={pensionBase?.BankAccountInstructions || []}
                            OwnerHierarchyId={pensionBase?.OwnerHierarchyId}
                            showPropotionOfPcls={
                                subAccountType === SubAccountType.Npr &&
                                processType !== processTypeEnum.EditIncomePayments
                            }
                            onChangeBankAccountInstructions={(changes) => {
                                this.onDataChange(onChange, changes, pensionBase, "BankAccountInstructions");
                            }}
                            initialBankPaymentMethod={
                                processType == processTypeEnum.EditIncomePayments &&
                                (!data?.DrawdownIncomeAmendmentInstruction?.Income?.PaymentMethod ||
                                    data?.DrawdownIncomeAmendmentInstruction?.Income?.PaymentMethod ==
                                        PaymentMethod.InternalTransfer)
                                    ? PaymentMethod.Faster
                                    : null
                            }
                            onPaymentMethodChange={async (value) => {
                                await this.handleChange({ PaymentMethod: value }, "Income");
                            }}
                        />
                    </>
                )}
                {!data?.DrawdownIncomeAmendmentInstruction?.Income?.TaxableIncomeRequiredInAddition && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={"It will cancel the active income drawdown instruction"}
                    />
                )}
            </PartLoading>
        );
    }
}
